/* Converts a hex-encoded string to a UTF-8 string */
export const hexToAscii = (hex: string): string => new TextDecoder().decode(new Uint8Array((hex.match(/.{1,2}/g) ?? []).map((b) => parseInt(b, 16))));
